import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from  "rxjs";
import { Users } from '../classes/users'
import { catchError, finalize, map,tap } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { User } from '../classes/User';
import { ConstantsService } from './Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { UserOffices } from '../classes/UserOffices';
import { UserPractices } from '../classes/UserPractices';
import { AuthService } from 'src/app/shared/services/Auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private _refreshPage = new Subject<void>();
  private _resetFilters = new Subject<void>();
  private _resetHeaders = new Subject<void>();
  private _deleteUser = new Subject<void>();
  private _refreshwithFilters = new Subject<void>();
  private unsubscribe$ =new Subject<void>();
  //private _dataContextService: DataContextService;
  _dataContextService: any;
  
  get refreshPage()
  {
    return this._refreshPage;
  }

  get resetFilters()
  {
    return this._resetFilters;
  }

  get resetHeaders()
  {
    return this._resetHeaders;
  }

  get deleteUser()
  {
    return this._deleteUser;
  }
  get refreshwithFilters()
  {
    return this._refreshwithFilters;
  }
  private service_URL: any;
  headers = new HttpHeaders(); 

  constructor(private httpClient: HttpClient, private authService : AuthService) {
    this.service_URL = ConstantsService;
    this.headers = <HttpHeaders>authService.GetHttpHeader();
  }
  globalHeaders(): any {

    // let tokenNew = localStorage.getItem('authToken');    
    //     let headers = new HttpHeaders({
    //         'Access-Control-Allow-Origin' : '*',
    //         'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE',
    //         'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
    //         'Content-Type' : 'application/json', 
    //         'responseType' : 'ResponseContentType.Blob',
    //         'Authorization' : `Bearer ${tokenNew}`
    //     });

    }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  //To get all users data
 getUsersData() : Observable<any>
 {

   return this.httpClient.get(this.service_URL.Users.getUser,{headers: this.headers }).pipe(map((response) => {
      //return this.setUserEmployeeRoles(response);
      return response;
    }));
  }

  //Get user by id
 getUsersDataById(id:number) : Observable<any>
 {
     return this.httpClient.get(this.service_URL.Users.getUserById+id,{headers: this.headers }).pipe(map((response) => {
      return response;
    }));
  }
 deleteUsers<T>(_dataUrl: string, data: Object) : Observable<T> {

    let bodyString = JSON.stringify(data);

      return this.httpClient.delete(_dataUrl,data)

          .pipe(map((response: T ) => <T>response ),
        catchError(this.handleError),
        finalize(() => {

        }));


  }
  //Get all the users details
 getUserDetails(params: any):Observable<any>
 {

   return this.httpClient.post<User>(this.service_URL.Users.graphApi,{ 
     params: params,headers: this.headers}).
      pipe(map((response) => {
        return response;
      }));
  }

 AddUsersData(addUserData: User, userOffices:Array<UserOffices>, userPractices:Array<UserPractices>):Observable<any>{
  let data={
    Applicationuser:addUserData,
    userOffices:userOffices,
    userPractices:userPractices
    }
    return this.httpClient.post<any>(this.service_URL.Users.addUser,data,{headers: this.headers}).
      pipe(map((response) => {
        return response;
      }));



  }




  getMastersData()   : Observable<any> {
     
    return this.httpClient.get(this.service_URL.Users.getMasterData,
      { headers: this.headers }).pipe(map((response) => {
        //return this.setUserEmployeeRoles(response);
        return response;
      }));
       
  }
  getUser()  : Observable<any> {

    return this.httpClient.get(this.service_URL.Users.getUser,
      {headers: this.headers }).pipe(map((response) => {
      //return this.setUserEmployeeRoles(response);
      return response;
    }));
       
  }


  UpdateUsersData(addUserData: User, userOffices: Array<UserOffices>, userPractices?: Array<UserPractices>): Observable<any> {
    // return this.httpClient.post(this.service_URL.Users.updateUser,addUserData,{headers: <HttpHeaders> new HttpHeaders() }).
    // pipe(map((response) => {
    //   return response;
    // }));

    // return this._dataContextService.post(this.service_URL.Users.Update)
    //     .pipe(takeUntil(this.unsubscribe$))
    //     .subscribe((res => {

    //       return res;
    //     }));
    
    let data = {
      Applicationuser: addUserData,
      userOffices: userOffices,
      userPractices: userPractices || []
    }
      return this.httpClient.post<any>(this.service_URL.Users.updateUser, data, { headers: this.headers }).
      pipe(map((response) => {
        return response;
      }));
    }

}
